var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"goods"},[_c('v-head',{attrs:{"title":_vm.title}}),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_c('img',{attrs:{"src":_vm.PZUrl}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }